<template>
  <div class="container">
    <div>
      <div class="my-2"></div>
      <span class="p-3 mr-3 font-weight-bold">Indice Autori</span>

      <div class="custom-control custom-radio custom-control-inline">
        <input
          type="radio"
          id="customRadioInline1"
          name="customRadioInline1"
          class="custom-control-input"
          v-model="picked"
          value="nome"
        />
        <label class="custom-control-label" for="customRadioInline1"
          >Ordina per nome</label
        >
      </div>

      <div class="custom-control custom-radio custom-control-inline">
        <input
          type="radio"
          id="customRadioInline2"
          name="customRadioInline1"
          class="custom-control-input"
          v-model="picked"
          value="totale"
        />
        <label class="custom-control-label" for="customRadioInline2"
          >Ordina per totale libri</label
        >
      </div>
    </div>

    <div class="d-flex flex-wrap">
      <button
        class="btn btn-secondary px-3 m-2"
        v-for="item in indexList"
        :key="item.initial"
        @click="loadAuthors(item.initial, $event)"
      >
        {{ item.initial }}
      </button>
    </div>
    <hr />
    <div v-if="authorList.length > 0">
      <p class="pl-2">
        <span class="mr-4">{{ sortedAuthorList.length }} autori trovati.</span>

        <input
          style="width: 250px;"
          type="text"
          v-model="searchText"
          placeholder="Filtra autore..."
        />
      </p>
    </div>

    <div class="d-flex flex-wrap justify-content-between">
      <button
        class="btn btn-light py-4 px-3 m-2"
        @click="goToAuthorBooks(item.autore, $event)"
        v-for="(item, index) in sortedAuthorList"
        :key="index"
      >
        {{ item.autore }} ({{ item.cnt }})
      </button>
    </div>
  </div>
</template>

<script>
import appService from "@/service.js";
var _ = require("lodash");

export default {
  data() {
    return {
      picked: "nome",
      indexList: [],
      authorList: [],
      searchText: ""
    };
  },
  computed: {
    sortedAuthorList() {
      //filtra e sorta lista autori
      let ret = this.authorList;
      if (this.searchText.length > 0) {
        let t = _.deburr(this.searchText.toLowerCase());
        let l = _.filter(this.authorList, function(item) {
          let a = _.deburr(item.autore.toLowerCase());
          return a.indexOf(t) > -1;
        });
        ret = _.sortBy(l, "autore");
      }

      if (this.picked == "totale") {
        let a = _.sortBy(ret, "cnt").reverse();
        return a;
      }

      return _.sortBy(ret, "autore");
    }
  },
  methods: {
    loadIndex() {
      appService.getAuthorsIndex().then(data => {
        //debugger
        this.indexList = data.data;
      });
    },
    loadAuthors(initial) {
      this.searchText = "";
      appService.getAuthors(initial).then(data => {
        this.authorList = data.data;
      });
    },
    goToAuthorBooks(author) {
      let pageSize = $cookies.get("pageSize") || 10;

      //debugger
      this.$store.commit("setLibraryQuery", {
        searchField: "autore",
        searchText: author,
        orderBy: "id",
        dir: 0,
        page: 1,
        pageSize: pageSize
      });

      this.$router.push("/library");
    }
  },
  mounted() {
    this.loadIndex();
  }
};
</script>

<style lang="scss" scoped></style>
